import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { Staff } from '../AllTableClasses';
import UserSession from '../Config/user-session';
import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(private ajax: CustomAjax,
    
  ) { }

  public StaffGet(searchCriteria: string, includeInactive: boolean, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Users/StaffGet", `searchCriteria=${searchCriteria}&includeInactive=${includeInactive}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public StaffSearch(searchCriteria: string, includeInactive: boolean, ProvinceID: number | null = UserSession.ProvinceID, BranchID: number | null = UserSession.BranchID, PageSize: number | null = 20, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Users/StaffSearch", `searchCriteria=${searchCriteria}&includeInactive=${includeInactive}&ProvinceID=${ProvinceID}&BranchID=${BranchID}&PageSize=${PageSize}`,
      (data) => {
        if (fn)
          fn(data);
        
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }


  public StaffGetByBranchID(BranchID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Users/StaffGetByBranchID", `BranchID=${BranchID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public StaffGetByGuid(guid: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Users/StaffGetByGuid", `guid=${guid}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public menuItemsGetByRoleID(RoleID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/Users/menuItemsGetByRoleID", `RoleID=${RoleID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public StaffSetByGuid(staff: Staff, fn: (data: any) => void, fnError: (error: any) => void): any {
    if (staff.Guid == null || staff.Guid == "") {
      staff.Password = this.generateStrongPassword(12, true, false, true);
    }

    this.ajax.PostData("/Users/StaffSetByGuid", staff,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
  public generateStrongPassword(length: number, addUpper: boolean, addSymbols: boolean, addNums: boolean) {
    var lower = "abcdefghijklmnopqrstuvwxyz";
    var upper = addUpper ? lower.toUpperCase() : "";
    var nums = addNums ? "0123456789" : "";
    var symbols = addSymbols ? "!#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~" : "";

    var all = lower + upper + nums + symbols;
    while (true) {
      var pass = "";
      for (var i = 0; i < length; i++) {
        pass += all[Math.random() * all.length | 0];
      }

      // criteria:
      if (!/[a-z]/.test(pass)) continue; // lowercase is a must
      if (addUpper && !/[A-Z]/.test(pass)) continue; // check uppercase
      if (addSymbols && !/\W/.test(pass)) continue; // check symbols
      if (addNums && !/\d/.test(pass)) continue; // check nums

      return pass; // all good
    };
  };

  public ActivityHistoryGet(staffID: number, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Users/ActivityHistoryGet", `staffID=${staffID}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ActivityHistorySetInactive(staff: Staff, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Users/ActivityHistorySetInactive", staff,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }
}
